import { Grid } from '@material-ui/core';
import { useDevice } from 'components/DeviceContext.js';
import React from 'react';
import Grafico from 'components/Grafico';
import { Card1, Card2 } from 'components/Card';
const CenarioMunicipal = () => {
    const { isMobile } = useDevice();
    return (
        <>
            <Grid item xs={12} md={12} style={{
                display: 'flex',
                justifyContent: 'center',
                maxHeight: '100%',
                margin: isMobile ? '1em' : '1em 0 6em 0',
                flexDirection: isMobile ? 'column': '',
                fontFamily: 'Open sans',
                fontWeight: 400,
            }}>
                <Grid item xs={12} md={5} lg={5}>
                    <h3 style={{
                        color: 'var(--azul-vivido)',
                        fontWeight: 400,
                        fontSize: isMobile ? '1.4em' : '2.5rem'
                    }}>Acompanhe o cenário municipal do FIA</h3>
                    <p>
                        Em 2017 a CNM lançou a campanha nacional on-line <span>“Municípios pela infância e adolescência”</span>,
                        por meio do site fia.org.br, disponibilizando informações relevantes sobre a situação dos Fundos Municipais
                        dos Direitos da Criança e do Adolescente-FIA.
                    </p>
                    <p>
                        Desde o início da campanha a entidade realiza várias ações no intuito de estimular os gestores municipais e sua
                        equipe, para que assumam o compromisso de criar e/ou regularizar a situação dos seus FIA’s, bem como realizar campanhas
                        para mobilizar a população realizar doações, e assim aumentar a receita municipal, para financiar projetos sociais,
                        que garantam a promoção e defesa dos direitos da criança e do adolescente.
                    </p>

                    <Grid>
                        <Grafico />

                    </Grid>
                <h1>
                    <small style={{fontSize: '0.4em'}}>
                        <strong >Fonte:</strong>
                        SNDCA/MDH – Elaboração CNM.
                    </small>
                </h1>
                <hr />

                <table id="datatable" className="tabela-cenario-fia">
                    <thead>
                        <tr>
                            <th ></th>
                            {/* <th className="ano-tabela-cenario-fia" style={{backgroundColor:'var(--azul-vivido)', padding: '1em', color:'var(--branco)'}}>2017</th>
                            <th className="ano-tabela-cenario-fia" style={{backgroundColor:'var(--azul-vivido)', padding: '1em', color:'var(--branco)'}}>2018</th> */}
                            <th className="ano-tabela-cenario-fia" style={{backgroundColor:'var(--azul-vivido)', padding: '1em', color:'var(--branco)'}}>2020</th>
                            <th className="ano-tabela-cenario-fia" style={{backgroundColor:'var(--azul-vivido)', padding: '1em', color:'var(--branco)'}}>2021</th>
                            <th className="ano-tabela-cenario-fia" style={{backgroundColor:'var(--azul-vivido)', padding: '1em', color:'var(--branco)'}}>2022</th>
                            <th className="ano-tabela-cenario-fia" style={{backgroundColor:'var(--azul-vivido)', padding: '1em', color:'var(--branco)'}}>2023</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr style={{backgroundColor: 'var(--cinza)', textAlign: 'center'}}>
                            <td className="titulo-tabela-cenario-fia" style={{padding: '1em'}}>
                                Municípios sem doações do IR (Pessoa Física - PGD IRPF)
                            </td>
                            {/* <td>321</td>
                            <td>347</td> */}
                            <td>3821</td>
                            <td>3469</td>
                            <td>2932</td>
                            <td>2686</td>
                        </tr>

                        <tr style={{ textAlign: 'center'}}>
                            <td className="titulo-tabela-cenario-fia">
                                Municípios com regitro/cadastro de dados inconsistente ou incompleto na SNDCA/MDH</td>
                            {/* <td>
                                <p className="tooltip-tabela-cenario-fia" data-toggle="tooltip" data-placement="bottom" title="Fonte: Dados do último cadastro nacional finalizado em 13 de novembro de 2016, realizado pela Secretaria Nacional dos Direitos da Criança e do Adolescente (SNDCA/MDH)">
                                    1010
                                    <i className="fa fa-exclamation-circle no-print" aria-hidden="true" style={{color: '#ff9600', marginLeft: '15px'}}></i>
                                </p>
                            </td>

                            <td>
                                <p className="tooltip-tabela-cenario-fia" data-toggle="tooltip" data-placement="bottom" title="Fonte: Dados do último cadastro nacional finalizado em 11 de outubro de 2017, realizado pela Secretaria Nacional dos Direitos da Criança e do Adolescente (SNDCA/MDH)">
                                    699
                                    <i className="fa fa-exclamation-circle no-print" aria-hidden="true" style={{color: '#ff9600', marginLeft: '15px'}}></i>
                                </p>
                            </td> */}

                            <td>
                                <p className="tooltip-tabela-cenario-fia" data-toggle="tooltip" data-placement="bottom" title="Fonte: Dados do último cadastro nacional em 2018, realizado pela Secretaria Nacional dos Direitos da Criança e do Adolescente (SNDCA/MDH)">
                                1640
                                    <i className="fa fa-exclamation-circle no-print" aria-hidden="true" style={{color: '#ff9600', marginLeft: '15px'}}></i>
                                </p>
                            </td>
                            <td>
                                <p className="tooltip-tabela-cenario-fia" data-toggle="tooltip" data-placement="bottom" title="Fonte: Dados do último cadastro nacional em 2018, realizado pela Secretaria Nacional dos Direitos da Criança e do Adolescente (SNDCA/MDH)">
                                1495
                                    <i className="fa fa-exclamation-circle no-print" aria-hidden="true" style={{color: '#ff9600', marginLeft: '15px'}}></i>
                                </p>
                            </td>
                            <td>
                                <p className="tooltip-tabela-cenario-fia" data-toggle="tooltip" data-placement="bottom" title="Fonte: Dados do último cadastro nacional em 2018, realizado pela Secretaria Nacional dos Direitos da Criança e do Adolescente (SNDCA/MDH)">
                                789
                                    <i className="fa fa-exclamation-circle no-print" aria-hidden="true" style={{color: '#ff9600', marginLeft: '15px'}}></i>
                                </p>
                            </td>
                            <td>
                                <p className="tooltip-tabela-cenario-fia" data-toggle="tooltip" data-placement="bottom" title="Fonte: Dados do último cadastro nacional em 2018, realizado pela Secretaria Nacional dos Direitos da Criança e do Adolescente (SNDCA/MDH)">
                                807
                                    <i className="fa fa-exclamation-circle no-print" aria-hidden="true" style={{color: '#ff9600', marginLeft: '15px'}}></i>
                                </p>
                            </td>
                        </tr>
                        <tr style={{backgroundColor: 'var(--cinza)',  textAlign: 'center'}}>
                            <td className="titulo-tabela-cenario-fia" style={{padding: '1em'}}>Municípios que receberam repasse de doações do IR (Pessoa Física - PGD IRPF)</td>
                            {/* <td>1191</td>
                            <td>1355</td> */}
                            <td>1747</td>
                            <td>2099</td>
                            <td>2636</td>
                            <td>2882</td>

                        </tr>
                        <tr style={{ textAlign: 'center'}}>
                            <td className="titulo-tabela-cenario-fia" style={{padding: '1em'}}>Municípios que não possuem cadastro na SNDCA/MDH</td>
                            {/* <td>3046</td>
                            <td>3167</td> */}
                            <td>2181</td>
                            <td>1974</td>
                            <td>2143</td>
                            <td>1879</td>
                        </tr>
                    </tbody>
                </table>
                </Grid>
                <Grid item xs={12} md={5} lg={4}style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    <Card1 />
                    <Card2 />

                </Grid>
            </Grid>

        </>
    )
}

export default CenarioMunicipal;
